import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import Markdown from "../../components/markdown/Markdown";

interface Text {
    value: string;
    caret: number;
    target: EventTarget | null;
}
export default function MarkdownEditor() {
    const [text, setText] = useState<Text>({ value: `# Hello world!\nAdd some markdown!`, caret: -1, target: null });
    const spaces = 4;
    useEffect(() => {
        if (text.caret >= 0) {
            // @ts-ignore
            text.target?.setSelectionRange(text.caret + spaces, text.caret + spaces);
        }
    }, [text]);

    const handleTab = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        let content = e.currentTarget.value;
        let caret = e.currentTarget.selectionStart;

        if (e.key === "Tab") {
            e.preventDefault();

            let newText = content.substring(0, caret) + " ".repeat(spaces) + content.substring(caret);

            setText({ value: newText, caret: caret, target: e.target });
        }
    };
    function countCharacters(input: string): number {
        return input.length;
    }

    function countWords(input: string): number {
        const words = input.split(/\s+/).filter((word) => /^[A-Za-z]+$/.test(word));
        return words.length;
    }

    const handleText = (e: React.ChangeEvent<HTMLTextAreaElement>) => setText({ value: e.target.value, caret: -1, target: e.target });

    return (
        <>
            <Helmet>
                <title>ReinVB Studio — Markdown</title>
            </Helmet>
            <div className="mx-8 rounded border px-4 py-2 text-sm text-slate-500 dark:text-slate-500">
                <p>
                    {countWords(text.value)} words — {countCharacters(text.value)} characters
                </p>
            </div>
            <div className="mx-8 my-4 grid grid-cols-2 gap-4 overflow-hidden rounded-lg border shadow-lg">
                <div className="h-[calc(100dvh-8rem)] w-full">
                    <textarea
                        placeholder="Insert your markdown..."
                        onKeyDown={(e) => handleTab(e)}
                        className="scrollbar h-[calc(100dvh-8rem)] w-full resize-none rounded-none border-r-2 bg-slate-100 p-4 focus-visible:outline-none dark:bg-slate-800"
                        value={text.value}
                        onChange={(e) => handleText(e)}></textarea>
                </div>
                <div className="scrollbar h-[calc(100dvh-8rem)] overflow-y-scroll p-4">
                    <Markdown className="max-w-full">{text.value}</Markdown>
                </div>
            </div>
        </>
    );
}
